import { XCircleIcon } from '@heroicons/react/24/solid';
import { Dialog, Slide, Box } from '@mui/material'
import HtmlWithDefaultStyles from '../DangerousHtml/HtmlWithDefaultStyles';


function Transition(props) {
    return <Slide direction="up" {...props} timeout={600} />;
}


const DialogBox = ({ open, setOpen, data }) => {

    return (
        <div>

            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="responsive-dialog-title"
                disableScrollLock={true}
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: '500px' },
                        borderRadius: '20px',
                    }
                }}

            >
                <div className='p-3 ' >

                    <Box display={'flex'} justifyContent='flex-end' >
                        <XCircleIcon className='h-[40px] cursor-pointer hover:rotate-animation text-black' onClick={() => setOpen(false)} />
                    </Box>
                    {data && (
                        <div>
                            <HtmlWithDefaultStyles htmlString={data.value} />
                        </div>
                    )}

                </div>
            </Dialog>

        </div>
    )
}

export default DialogBox